export default __webpack_public_path__ + "static/media/los-angeles.a6114713.png";